export const PACKAGE_NAME = 'redux-deep-persist';
export const PLACEHOLDER_UNDEFINED = '@@placeholder/undefined';
